<template>
  <div
    class="make-selection d-flex  flex-column"
  >
    <img
      class="mx-auto mt-0 mb-4"
      src="@/assets/calendar.png"
    >
    <div class="make-selection__text text-center">
      {{ text }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'MakeSelection',
  props: {
    text: {
      type: String,
      default: 'Please make selections from the section above in order to view available times'
    }
  }
}
</script>
<style lang="scss" scoped>
.make-selection {
  max-width: 300px;
  width: 100%;
}
</style>
